import { cn } from '@/utilities/ui'
import * as React from 'react'

const Textarea: React.FC<React.TextareaHTMLAttributes<HTMLTextAreaElement>> = ({
  className,
  ...props
}) => {
  return <textarea data-slot="textarea" className={cn('textarea-site', className)} {...props} />
}

export { Textarea }
